<template>
    <div class="footer">
      <section class="bottomMenu clearfix">
        <div class="menu clearfix">
          <ul class="navs">
            <li class="nav_list" ><router-link to="/home" tag="div" class="active_item" >首页</router-link></li>
            <li class="nav_list"><router-link to="/aboutUs" tag="div" class="active_item" >关于我们</router-link></li>
            <li class="nav_list"><router-link to="/companyThought" tag="div" class="active_item" >公司理念</router-link></li>
            <li class="nav_list"><router-link to="/contactUs" tag="div" class="active_item" >联系我们</router-link></li>
          </ul>
        </div>
        <div class="copyRight clearfix">
          <p>©2006-{{currentYear}}盈融达投资（北京）有限公司</p>
          <p> <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer nofollow" style="color:white;">京ICP备10030155号-1</a></p>
          <p>
            <a class='aStyle' href="http://www.beian.gov.cn/portal/registerSystemInfo/?recordcode=11010502031386" target="_blank" rel="noopener noreferrer nofollow">
                <img src="../assets/gong_an_bei_an.png" style="width: 20px">
                <span>京公网安备 11010502031386号</span>
            </a>
          </p>
        </div>
      </section>
    </div>
</template>
<script>
    export default {
        name: 'footer',
        components: {},

        props: {},

        data() {
            return {
              currentYear:new Date().getFullYear(),//当前年份
            }
        },

        computed: {},

        watch: {},

        created() {
        },

        mounted() {
        },

        destroyed() {
        },

        methods: {}
    }
</script>

<style scoped lang="scss">
  .footer{
    background-color: #f5f5f5;
    width: 100%;
    position: fixed;
    bottom: 0;
  }
    .bottomMenu{
       width:100%;
        .menu{
          width: 100%;
          .navs{
            display: flex;
            flex-direction: row;
            margin: 0 auto;
            width: 70%;
            justify-content: space-around;
          .nav_list{
            cursor: pointer;
            height: 5.625rem;
            line-height: 5.6rem;
            font-weight:500;
          }
         }
      }
    }
    .copyRight{
      background-color: #6e6e6e;
      color: #ccccca;
      display: flex;
      flex-direction: row;
      justify-content: center;
      width: 100%;
      font-size: 12px;
      padding: 25px 0;
      text-align: center;
        p{
          /*width: 100%;*/
          margin: 0;
          text-align: center;
        }
    }

    a{
      background-color: transparent;
    }
    .aStyle{
      display: inline-block;
      color: white;
      height: 20px;
      line-height: 20px;
    }
    .clearfix{
      display: table;
      content: " ";
    }
    img{
      vertical-align: middle;
      border: 0;
    }

@media screen and (min-width:1200px) {
  .bottomMenu{
    /*max-width: 1140px;*/
  }
}
@media screen and (min-width:768px) {
//   .footer{
//     margin-top: 88px;
//   }
  .bottomMenu{
    /*padding: 50px 0;*/
    /*margin: auto;*/
  }
  ul{
    margin-top: 50px;
  }
  .copyRight{
    float: left;
    width: 100%;
    font-size: 12px;
    padding: 25px 0;
    text-align: center;
    p{
      display: inline-block;
      padding: 0 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue